

class Tooltip {
    constructor() {
        this.tooltip = null;
        this.enabled = window.innerWidth > 750;
        this.bound = false;

        this._onResize = this._onResize.bind(this);
        window.addEventListener('resize', this._onResize);

        if (this.enabled) {
            this.bindEvents();
        }
    }

    _onResize() {
        const shouldEnable = window.innerWidth > 750;
        if (shouldEnable && !this.bound) {
            this.bindEvents();
            this.enabled = true;
        } else if (!shouldEnable && this.bound) {
            this.unbindEvents();
            this.enabled = false;
            this.hideTooltip();
        }
    }

    bindEvents() {
        this.targets = document.querySelectorAll('[js-tooltip-el]');
        this.targets.forEach(el => {
            el.addEventListener('mouseenter', this._onEnter = e => this.showTooltip(e.currentTarget));
            el.addEventListener('mouseleave', this._onLeave = () => this.hideTooltip());
            el.addEventListener('mousemove', this._onMove = e => this.moveTooltip(e));
        });
        this.bound = true;
    }

    unbindEvents() {
        if (!this.targets) return;
        this.targets.forEach(el => {
            el.removeEventListener('mouseenter', this._onEnter);
            el.removeEventListener('mouseleave', this._onLeave);
            el.removeEventListener('mousemove', this._onMove);
        });
        this.bound = false;
    }

    getContrastColor(rgbString) {
        const [r, g, b] = rgbString.match(/\d+/g).map(Number);
        const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
        return luminance > 0.5 ? "0 0 0" : "255 255 255";
    }

    createTooltip(content, backgroundColor) {
        const tooltip = document.createElement('div');
        tooltip.classList.add('js-tooltip', 'tooltip-el');
        tooltip.textContent = content;

        // minimal styles
        tooltip.style.position = 'fixed';
        tooltip.style.top = '-10px';
        tooltip.style.left = '0';
        tooltip.style.transform = 'translate(-50%, -100%)';
        tooltip.style.pointerEvents = 'none';

        if (backgroundColor) {
            tooltip.style.setProperty('--background', backgroundColor);
            tooltip.style.setProperty('--text-color', this.getContrastColor(backgroundColor));
        }
        document.body.appendChild(tooltip);
        return tooltip;
    }

    showTooltip(el) {
        if (!this.enabled) return;
        const content = el.getAttribute('tooltip-content');
        const backgroundColor = el.getAttribute('tooltip-bg');
        if (!content) return;
        if (this.tooltip) this.tooltip.remove();
        this.tooltip = this.createTooltip(content, backgroundColor);
    }

    moveTooltip(e) {
        if (!this.tooltip || !this.enabled) return;
        this.tooltip.style.top = `${e.clientY - 8}px`;
        this.tooltip.style.left = `${e.clientX}px`;
    }

    hideTooltip() {
        if (this.tooltip) {
            this.tooltip.remove();
            this.tooltip = null;
        }
    }
}

document.addEventListener('DOMContentLoaded', () => new Tooltip());
